import { FC, useState } from 'react';
import ActionGroupItemLabel from 'components/Shared/ActionsButtonDetailsPage/ActionGroupItemLabel';
import { EIconNames } from 'components/Base/Icon';
import { TWorkshopDetailsDataUI } from 'data/types/workshops.types';
import AddRegistrationModal from './AddRegistrationModal/AddRegistrationModal';

type Props = { id: string; workshop: TWorkshopDetailsDataUI };

const AddRegistrationAction: FC<Props> = ({ id, workshop }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ActionGroupItemLabel
        label="Add Registration"
        icon={EIconNames.PLUS}
        onClick={() => setOpen(true)}
      />
      {open && (
        <AddRegistrationModal
          open={open}
          setOpen={setOpen}
          workshopId={id}
          workshop={workshop}
        />
      )}
    </>
  );
};

export default AddRegistrationAction;
